module.exports = __webpack_public_path__ + "media/images/press_kit/test/email/top-light-e130037be5fba8aa2e5563d448a675d0.png";